<template>
    <transition name="fade" mode="out-in">
        <div class="pop form__customform_notify form__customform_notifypreview" v-show="isActive">
            <div class="form__customform_notify_overlay"></div>
            <div class="form__customform_notify_box" v-if="isActive">
                <header class="form__customform_notify_box_header">
                    <div class="form__customform_notify_box_header_title">
                        {{ title }}
                        <span
                            v-if="subtitle"
                            class="form__customform_notify_box_header_title_subtitle"
                        >{{ subtitle }}</span>
                    </div>
                    <div class="form__customform_notify_box_header_close">
                        <component-button
                            :name="'form-customform-notify-preview-close'"
                            :icon="true"
                            :icon-name="'x'"
                            :icon-raw="true"
                            @click="closeNotify"
                        ></component-button>
                    </div>
                </header>
                <div class="form__customform_notify_box_main">
                    <div class="form__customform_notify_box_main_content">
                        <ul class="form__customform_notify_box_main_content_fields">
                            <li
                                :class="`form__customform_box_middle_fields--${item.type}`"
                                v-for="(item, index) in items"
                                :key="index"
                            >
                                <component
                                    :is="`form-${formFields[item.type]}`"
                                    :label="item.label"
                                    :name="`${item.label}-${index}-preview` | toKebabCase"
                                    :required="item.validation.mandatory"
                                    :value="item.answers"
                                    :items="filteredOptions(item.options, item.type)"
                                    :other="item.additional.other"
                                    :width="'full'"
                                    :disabled="disabled"
                                    :multiple="true"
                                >{{ item.helpText }}</component>
                            </li>
                        </ul>
                    </div>
                </div>
                <template v-if="!disabled">
                    <footer class="form__customform_notify_box_footer">
                        <div class="form__customform_notify_box_footer_actions">
                            <div class="columns columns--flex">
                                <div class="column"></div>
                                <template v-if="cancelButtonActive">
                                    <div class="column is-narrow">
                                        <component-button
                                            :theme="'default'"
                                            :border="true"
                                            :name="'form-customform-notify-box-footer-actions-cancel'"
                                            @click="closeNotify"
                                        >{{ cancelButtonText }}
                                        </component-button>
                                    </div>
                                </template>
                                <template v-if="submitButtonActive">
                                    <div class="column is-narrow">
                                        <component-button
                                            :theme="'primary'"
                                            :name="'form-customform-notify-box-footer-actions-submit'"
                                            @click="closeNotify"
                                        >{{ submitButtonText }}
                                        </component-button>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </footer>
                </template>
            </div>
        </div>
    </transition>
</template>

<script>
import FormText from '@/components/default/forms/FormText'
import FormRadioHorizontal from '@/components/default/forms/FormRadioHorizontal'
import FormTextarea from '@/components/default/forms/FormTextarea'
import FormCheckbox from '@/components/default/forms/FormCheckbox'
import FormSelect from '@/components/default/forms/FormSelect'
import ComponentButton from '@/components/default/shared/ComponentButton'

export default {
  components: {
    FormCheckbox,
    FormTextarea,
    FormRadioHorizontal,
    FormText,
    FormSelect,
    ComponentButton
  },
  name: 'form-customform-notifypreview',
  data () {
    return {
      isActive: false,
      formFields: {
        'text': 'text',
        'checkbox': 'checkbox',
        'single-choice': 'radio-horizontal',
        'multi-choice': 'select'
      },
      formValues: []
    }
  },
  props: {
    title: {
      type: String,
      required: true,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    //
    submitButtonText: {
      type: String,
      default: function () {
        return this.$t('forms.customForm.buttons.submitForm')
      }
    },
    submitButtonActive: {
      type: Boolean,
      default: true
    },
    //
    cancelButtonText: {
      type: String,
      default: function () {
        return this.$t('forms.customForm.buttons.cancel')
      }
    },
    cancelButtonActive: {
      type: Boolean,
      default: true
    },
    //
    disabled: {
      type: Boolean,
      default: false
    },
    items: {
      type: [Array, Object],
      required: true,
      default: () => {
      }
    }
  },
  mounted () {
    let self = this
    let overlay = document.getElementsByClassName('form__customform_notify_overlay')
    for (let i = 0; i < overlay.length; i++) {
      overlay[i].addEventListener('click', function () {
        self.closeNotify()
      })
    }
  },
  methods: {
    closeNotify: function () {
      this.isActive = false
      this.form = {
        id: '',
        label: '',
        type: '',
        validation: {
          mandatory: false
        },
        helpText: '',
        options: '',
        other: ''
      }
      this.update = false
      this.updateIndex = ''
    },
    openNotify: function () {
      this.isActive = true
    },
    updateNotify: function (form, index) {
      this.form = JSON.parse(JSON.stringify(form))
      this.update = true
      this.updateIndex = index
    },
    //
    filteredOptions: function (items, type) {
      if (type === 'single-choice') {
        return this.fromStringToArrayRadio(items)
      } else {
        return this.fromStringToArraySelect(items)
      }
    },
    //
    submit: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.update) {
            this.$emit('emit-edit', this.form, this.updateIndex)
          } else {
            this.$emit('emit-add', this.form)
          }
          this.closeNotify()
        }
      })
    },
    remove: function () {
      this.$emit('emit-remove', this.updateIndex)
      this.closeNotify()
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/forms/formcustomformnotify";
</style>
